import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button as OriginButton } from 'eone-ui/buttons/button';
import { FormError as OriginFormError } from 'eone-ui/forms/form-error';
import { FormString as OriginFormString } from 'eone-ui/forms/form-string';
import { InputString as OriginInputString } from 'eone-ui/inputs/input-string';
import { Navigation as OriginNavigation } from 'eone-ui/navigation/navigation';
import { FormPanel as OriginFormPanel } from 'eone-ui/panels/form-panel';
import { RadioGroup as OriginRadioGroup } from 'eone-ui/radio/radio';

interface ButtonProps {
  Label?: string | React.ReactNode;
  Icon?: IconProp;
  Danger?: boolean;
  MenuItems?: {
    Divider?: boolean;
    Label: string;
    /** font awesome icon */
    Icon?: IconProp;
    OnClick?: (data?: any) => void;
    Visible?: boolean;
    Danger?: boolean;
    DataTestId?: string;
    Data?: any;
  }[];
  Title?: string;
  AccessKey?: string;
  DataTestId?: string;
  Disabled?: boolean;
  Class?: string;
  Style?: React.CSSProperties;
  Grow?: boolean;
  TitleAlign?: string;
  Type?: 'danger' | 'primary' | 'secondary' | 'tertiary';
  OnClick?: () => void;
}

export const Button = (props: ButtonProps) => {
  const getClass = () => {
    if (props.Class) return props.Class;
    let className = 'eone-ui-button-container';
    switch (props.Type) {
      case 'primary': {
        className += '-primary';
        break;
      }
      case 'secondary': {
        className += '-secondary';
        break;
      }
      case 'tertiary': {
        className += '-tertiary';
        break;
      }
      case 'danger': {
        className += '-danger';
        break;
      }
      default: {
        className += '-primary';
        break;
      }
    }
    return className;
  };

  // @ts-ignore
  return <OriginButton Class={getClass()} {...props} />;
};

interface SuffixButton {
  Title: string;
  Visible: boolean;
  Icon: IconProp;
  OnClick: any;
}

interface InputStringProps {
  Id?: string;
  Value?: string;
  OnChange?: (value: string) => void;
  Disabled?: boolean;
  Required?: boolean;
  ReadOnly?: boolean;
  ShowCopyButton?: boolean;
  SuffixButtons?: SuffixButton[];

  AutoFocus?: boolean;
  Icon?: IconProp;
  Placeholder?: string;
}

export const InputString = (props: InputStringProps) => {
  return <OriginInputString {...props} />;
};

interface NavigationProps {
  Sections?: {
    Items: {
      Item: string;
      Label: string;
      /** font awesome icon */
      Icon?: IconProp;
    }[];
    Label: string;
  }[];
  Items?: {
    Item: string;
    Label: string;
    /** font awesome icon */
    Icon?: IconProp;
  }[];
  /** default Settings */
  ItemsLabel?: string;
  Selected?: string;
  OnClick?: (item: string) => void;
  Collapsible?: boolean;
  DataTestId?: string;
  children?: React.ReactNode;
}

export const Navigation = (props: NavigationProps) => {
  return <OriginNavigation {...props} />;
};

interface FormPanelHeaderButtonProps {
  Id?: string;
  Label: string;
  Icon?: IconProp;
  OnClick?: () => void;
  Primary?: boolean;
  Tertiary?: boolean;
  Danger?: boolean;
  Disabled?: boolean;
  Visible?: boolean;
  Priority?: number;
  MenuItems?: {
    Divider?: boolean;
    Label: string;
    Icon?: IconProp;
    Disabled?: boolean;
    OnClick: () => void;
  }[];
}

interface FormPanelProps {
  Title: string;
  Icon?: IconProp;
  Card?: boolean;
  HeaderButtons?: FormPanelHeaderButtonProps[];
  DataTestId?: string;
  Loading?: boolean;
  children: React.ReactNode;
}

export const FormPanel = (props: FormPanelProps) => {
  return <OriginFormPanel {...props} />;
};

interface FormErrorProps {
  Message: string;
  Visible: boolean;
}

export const FormError = (props: FormErrorProps) => {
  return <OriginFormError {...props} />;
};

interface FormStringProps extends InputStringProps {
  Label: string;
  Required?: boolean;
  ShowRequiredIndicator?: boolean;
  Visible?: boolean;
  Password?: boolean;
  MaxLength?: number;
  ValidChars?: string[];
  InvalidChars?: string[];
  ErrorMessage?: string;
  DataTestId?: string;
}

export const FormString = (props: FormStringProps) => {
  return <OriginFormString {...props} />;
};

interface RadioGroupProps {
  Value?: string;
  Buttons: {
    Label: string;
    Value: string;
  }[];
  OnChange?: (value: string) => void;
  Disabled?: boolean;
}

export const RadioGroup = (props: RadioGroupProps) => {
  return <OriginRadioGroup {...props} />;
};
